var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPrev = function SvgPrev(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.53 2.196a.75.75 0 0 0-1.06-1.06l-9.333 9.333a.747.747 0 0 0-.002 1.06h.002m0 .001 9.333 9.333a.75.75 0 0 0 1.06-1.06l-8.052-8.054h16.856a.75.75 0 1 0 0-1.5H3.478l8.053-8.053",
    fill: "#A9B0B4"
  })));
};
export default SvgPrev;